import { atom, atomFamily, useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';

export const chosenPositions = atom({
  key: 'chosenPositions',
  default: null,
});

export const defaultNodes = atom({
  key: 'defaultNodes',
  default: [
    {
      hierarchy: 0,
      type: 'plant',
      label: 'Planta',
      kind: 'position',
    },
    {
      hierarchy: 1,
      type: 'area',
      label: 'Area',
      kind: 'position',
    },
    {
      hierarchy: 2,
      type: 'sub-area',
      label: 'Sub-Area',
      kind: 'position',
    },
    {
      hierarchy: 3,
      type: 'line',
      label: 'Linha',
      kind: 'position',
    },
    {
      hierarchy: 0,
      type: 'machine',
      label: 'Máquina',
      kind: 'asset',
    },
    {
      hierarchy: 1,
      type: 'assembly',
      label: 'Conjunto',
      kind: 'asset',
    },
    {
      hierarchy: 2,
      type: 'equipment',
      label: 'Equipamento',
      kind: 'asset',
    },
    {
      hierarchy: 3,
      type: 'component',
      label: 'Componente',
      kind: 'asset',
    },
  ],
});


export const viewDetailsCategory = atom({
  key: 'viewDetailsCategory',
  default: null,
});

export const viewDetailsCategories = atom({
  key: 'viewDetailsCategories',
  default: null,
});

export const commonStages = atom({
  key: 'commonCriterias',
  default: [],
});

export const userGroups = atom({
  key: 'userGroups',
  default: {},
});

export const categories = atom({
  key: 'categories',
  default: [],
});


export default function useSettingsState() {
  return {
    chosenPositions: useRecoilValue(chosenPositions),
    setChosenPositions: useSetRecoilState(chosenPositions),
    defaultNodes: useRecoilValue(defaultNodes),
    setDefaultNodes: useSetRecoilState(defaultNodes),
    viewDetailsCategory: useRecoilValue(viewDetailsCategory),
    setViewDetailsCategory: useSetRecoilState(viewDetailsCategory),
    viewDetailsCategories: useRecoilValue(viewDetailsCategories),
    setViewDetailsCategories: useSetRecoilState(viewDetailsCategories),
    commonStages: useRecoilValue(commonStages),
    setCommonStages: useSetRecoilState(commonStages),
    userGroups: useRecoilValue(userGroups),
    setUserGroups: useSetRecoilState(userGroups),
    categories: useRecoilValue(categories),
    setCategories: useSetRecoilState(categories),
  };
}
